import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'dot-prop';

@Pipe({
    name: 'count',
    standalone: true
})
export class CountPipe implements PipeTransform {
    transform(array: Array<any>, key: string, unique?: boolean): number {
        // if key is provided...
        if (key) {
            // ...and unique is true...
            if (unique) {
                // ...return the number of unique values in the array
                return [...new Set(array.map((item) => get(item, key)))].length;
            } else {
                // ...otherwise, return the number of items in the array that have a value for the key
                return array.filter((item) => get(item, key) != null).length;
            }
        }
        return array?.length;
    }
}
